import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const ContactUsItem = ({ title, description, onButtonClick, buttonText, children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'background.paper',
        borderRadius: '16px',
        padding: 2,
        border: '1px solid #f2f2f2',
        boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.05)', // Very subtle and smudgy shadow
        margin: 1,
        flexDirection: { xs: 'column', sm: 'row' }, // Responsive layout
      }}
    >
      <Box
        sx={{
          width: '50px',
          height: '50px',
          borderRadius: '12px',
          border: '1px solid #f2f2f2',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.05)', // Very subtle and smudgy shadow
color:"#828282",
          marginRight: { sm: 2, xs: 0 }, // Adjust margin for small screens
          marginBottom: { xs: 1, sm: 0 }, // Add bottom margin on small screens
        }}
      >
        {children} {/* Render the passed icon here */}
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="body2" sx={{
          fontWeight: 500,
          fontSize: '0.9rem',
        }}>{title}</Typography>
        <Typography variant="body2" sx={{
          color: '#828282',
        }}>{description}</Typography>
      </Box>
      <Button
        variant="contained"
        onClick={onButtonClick}
        sx={{
          backgroundColor: 'black',
          color: 'white',
          padding: '6px 24px',
          borderRadius: '20px',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: 'grey.800',
          },
        }}
      >
        {buttonText} {/* Render the button text from the prop */}
      </Button>
    </Box>
  );
};

export default ContactUsItem;
